<template>
  <div>
    <Menu></Menu>
    <div class="card">
      <div class="item item-text-wrap">
          Manage your account's settings on this page.
      </div>
    </div>

    <div class="padding">
        Choose the interval between you wish to be notified of new episodes of the story.
        <p>This app can notify you by email when there is a new episode for you to read.</p>
        <ion-toggle v-model="settings.email_notify" toggle-class="toggle-calm">Send e-mail for new episodes</ion-toggle>

        <button class="button button-block button-stable" ui-sref="app.changepassword">Change password</button>
        <button class="button button-block button-stable" ng-click="confirmReset()">Reset journey</button>

        <ion-toggle v-model="settings.debug" toggle-class="toggle-calm">Developer mode</ion-toggle>
    </div>
  </div>
</template>

<script>
export default {

  name: 'Settings',

  data () {
    return {
      settings: {
        episode_interval: null,
        debug: false,
        email_notify: true
      }
    }
  },
  components: {
  },
  methods: {
    // Triggered when `childToParent` event is emitted by the child.
    onChildClick (value) {
      this.episode_interval = value
    }
  }
}
</script>

<style lang="css" scoped>
</style>
